import { Injectable } from '@angular/core';
import { ISpacers } from '../_shared/models/spacers.model';

@Injectable({
    providedIn: 'root',
})
export class SectionService {
    private _backgroundColors = new Map<string, string>();
    // Sections without spacers (an edge-to-edge band); the section after one always gets a top spacer.
    private _flushSections = new Set<string>();

    addBackgroundColor(id: string, value: string, flush = false) {
        this._backgroundColors.set(id, value);

        if (flush) {
            this._flushSections.add(id);
        }
    }

    removeBackgroundColor(id: string): void {
        this._backgroundColors.delete(id);
        this._flushSections.delete(id);
    }

    getSpacers(id: string, hasBottomSpacer = true, hasTopSpacer = true): ISpacers {
        const spacers: ISpacers = {
            top: hasTopSpacer && this.hasColorChanged(id),
            bottom: hasBottomSpacer,
        };

        return spacers;
    }

    private hasColorChanged(id: string): boolean {
        if (this._backgroundColors.size < 2) return false;

        const size = this._backgroundColors.size;
        const color = this._backgroundColors.get(id);
        const [prevId, prevColor] = [...this._backgroundColors][size - 2];

        return this._flushSections.has(prevId) || color !== prevColor;
    }
}
